import React from 'react';
import { Logo, EntityLink } from './ui';

export default function LeagueTeams({ data }) {
  const teams = data?.teams || [];
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3">
      {(Array.isArray(teams) ? teams : []).map((t, i) => (
        <div key={t?.id ?? i} className="i-card i-club-card p-4">
          {t?.id ? (
            <EntityLink to={`/club/${t.id}`} className="flex items-center gap-3">
              <Logo src={t?.image_path} alt={t?.name} size={38} fallback={t?.name} />
              <div className="min-w-0">
                <div className="i-fg font-medium truncate">{t?.name || '—'}</div>
                {t?.short_code && <div className="i-mute text-xs">{t.short_code}</div>}
                {t?.country?.name && <div className="i-dim text-xs">{t.country.name}</div>}
              </div>
            </EntityLink>
          ) : (
            <div className="flex items-center gap-3">
              <Logo src={t?.image_path} alt={t?.name} size={38} fallback={t?.name} />
              <div className="min-w-0">
                <div className="i-mute truncate">{t?.name || '—'}</div>
                {t?.short_code && <div className="i-dim text-xs">{t.short_code}</div>}
              </div>
            </div>
          )}
        </div>
      ))}
      {!teams.length && <p className="i-dim text-sm col-span-full">No teams in this league.</p>}
    </div>
  );
}
